import { getType } from 'typesafe-actions';
import produce from 'immer';

import { ActionsOf } from '../../../helpers/actions';
import * as utilitiesActions from './actions';

import { Utility } from 'src/components/modules/sites/types';

export interface UtilityEntityState {
  byId: { [Key: number]: { id: number; name: string } };
}

export interface UtilityStateSlice {
  entities: {
    utility: UtilityEntityState;
  };
}

export const initialState: UtilityEntityState = {
  byId: {},
};

type UtilityActions = ActionsOf<typeof utilitiesActions>;

export const utilityEntityReducer = produce((draft: UtilityEntityState, action: UtilityActions) => {
  switch (action.type) {
    case getType(utilitiesActions.getUtilitiesList.success): {
      const utilities = action.payload.result as Utility[];

      draft.byId = {
        ...draft.byId,
        ...utilities,
      };

      return;
    }

    default:
      break;
  }
}, initialState);
